export enum SubscriptionCardEnums {
  IMAGE_ALT = 'basic plan icon',
  POINTER_ICON_ALT = 'bullet icon',
  BUTTON_LABEL = 'Login'
}